import * as yup from 'yup';

import { CheckboxTextSchema } from '../../../common/ICheckboxText';

export const ConsultationFormSchema = yup.object({
  consultationDate: yup
    .date()
    .typeError('validation_incorrect_format')
    .required('validation_required')
    .nullable()
    .default(() => new Date()),
  participants: yup.string().required('validation_required'),
  fall: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  decubitus: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  movementMotivation: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  nutrition: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  fluidSupply: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  continence: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  painTreatment: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  chronicWoundTreatment: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  intertrigoRisk: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  gerontologicalPsychiatricDisorders: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  freedomRestriction: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('validation_required!'),
    otherwise: CheckboxTextSchema.nullable(),
  }),
  miscellaneous: yup.string().nullable(),
  rejectedActivities: yup.string().nullable(),
});

export const CreateConsultationFormSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(ConsultationFormSchema);

export const UpdateConsultationFormSchema = yup
  .object({
    residentId: yup.string().required(),
    id: yup.string().required(),
  })
  .concat(ConsultationFormSchema);

export type IConsultationForm = yup.InferType<typeof ConsultationFormSchema>;

export type IUpdateConsultationForm = yup.InferType<typeof UpdateConsultationFormSchema>;

export type ICreateConsultationForm = yup.InferType<typeof CreateConsultationFormSchema>;
